// import React from 'react';
// import { Modal, Button, Row, Col } from 'react-bootstrap';
// import { toast, ToastContainer } from 'react-toastify';
// import { FaWhatsapp, FaFacebookF, FaTwitter, FaSms, FaEnvelope, FaCopy } from 'react-icons/fa';

// const ShareLinkModal = ({ show, handleClose, shareUrl, message = "Check this out!", title = "Share This Page" }) => {
//   const encodedUrl = encodeURIComponent(shareUrl);
//   const encodedMessage = encodeURIComponent(message);

//   const handleCopy = () => {
//     navigator.clipboard.writeText(shareUrl).then(() => {
//       toast.success("Link copied to clipboard!");
//       handleClose();
//     });
//   };

//   const handleShare = (type) => {
//     let url = '';

//     switch (type) {
//       case 'whatsapp':
//         url = `https://wa.me/?text=${encodedMessage}%20${encodedUrl}`;
//         break;
//       case 'sms':
//         url = `sms:?body=${encodedMessage}%20${encodedUrl}`;
//         break;
//       case 'email':
//         url = `mailto:?subject=${encodeURIComponent(title)}&body=${encodedMessage}%20${encodedUrl}`;
//         break;
//       case 'facebook':
//         url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
//         break;
//       case 'twitter':
//         url = `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`;
//         break;
//       default:
//         return;
//     }

//     window.open(url, '_blank');
//     handleClose();
//   };

//   const buttons = [
//     { type: 'whatsapp', icon: <FaWhatsapp />, label: 'WhatsApp', variant: 'success' },
//     { type: 'facebook', icon: <FaFacebookF />, label: 'Facebook', variant: 'primary' },
//     { type: 'twitter', icon: <i class="fa-brands fa-square-x-twitter"></i>, label: 'Twitter', variant: 'info' },
//     { type: 'sms', icon: <FaSms />, label: 'SMS', variant: 'secondary' },
//     { type: 'email', icon: <FaEnvelope />, label: 'Email', variant: 'warning' },
//     { type: 'copy', icon: <FaCopy />, label: 'Copy Link', variant: 'dark' },
//   ];

//   return (
//     <>
//       <Modal show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="text-center">
//             {buttons.map(({ type, icon, label, variant }) => (
//               <Col xs={6} md={4} className="mb-3" key={type}>
//                 <Button
//                   variant={variant}
//                   onClick={type === 'copy' ? handleCopy : () => handleShare(type)}
//                   className="w-100 d-flex flex-column align-items-center justify-content-center"
//                 >
//                   <span style={{ fontSize: '20px' }}>{icon}</span>
//                   <small>{label}</small>
//                 </Button>
//               </Col>
//             ))}
//           </Row>
//         </Modal.Body>
//       </Modal>

//       <ToastContainer position="top-center" autoClose={2000} hideProgressBar />
//     </>
//   );
// };

// export default ShareLinkModal;




import React from 'react';
import './shareModal.css'
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import {
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaSms,
  FaEnvelope,
  FaCopy,
} from 'react-icons/fa';
// import './ShareLinkModal.css'; // Import custom styles

const ShareLinkModal = ({
  show,
  handleClose,
  shareUrl,
  message,
  title = 'Share This Page',
}) => {
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedMessage = encodeURIComponent(message);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.success('Link copied to clipboard!');
      handleClose();
    });
  };

  const handleShare = (type) => {
    let url = '';

    switch (type) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodedMessage}%20${encodedUrl}`;
        break;
      case 'sms':
        url = `sms:?body=${encodedMessage}%20${encodedUrl}`;
        break;
      case 'email':
        url = `mailto:?subject=${encodeURIComponent(title)}&body=${encodedMessage}%20${encodedUrl}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
    handleClose();
  };

  const buttons = [
    { type: 'whatsapp', icon: <FaWhatsapp />, label: 'WhatsApp', variant: 'whatsapp' },
    { type: 'facebook', icon: <FaFacebookF />, label: 'Facebook', variant: 'facebook' },
    { type: 'twitter', icon: <FaTwitter />, label: 'Twitter', variant: 'twitter' },
    { type: 'sms', icon: <FaSms />, label: 'SMS', variant: 'sms' },
    { type: 'email', icon: <FaEnvelope />, label: 'Email', variant: 'email' },
    { type: 'copy', icon: <FaCopy />, label: 'Copy Link', variant: 'copy' },
  ];

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="text-center">
            {buttons.map(({ type, icon, label, variant }) => (
              <Col xs={6} md={4} className="mb-3" key={type}>
                <Button
                  variant="light"
                  onClick={type === 'copy' ? handleCopy : () => handleShare(type)}
                  className={`share-btn ${variant}`}
                >
                  <span className="icon">{icon}</span>
                  <small className="label">{label}</small>
                </Button>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

      <ToastContainer position="top-center" autoClose={2000} hideProgressBar />
    </>
  );
};

export default ShareLinkModal;
